import { render, staticRenderFns } from "./CaricamentoMassivoCard.vue?vue&type=template&id=c0a80906&scoped=true"
import script from "./CaricamentoMassivoCard.vue?vue&type=script&lang=ts"
export * from "./CaricamentoMassivoCard.vue?vue&type=script&lang=ts"
import style0 from "./CaricamentoMassivoCard.vue?vue&type=style&index=0&id=c0a80906&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a80906",
  null
  
)

export default component.exports